<template>
  <b-modal
    v-model="modal"
    size="md"
    dialog-class="rounded-[10px]"
    body-class="!px-[32px] !py-[3rem]"
    hide-header
    hide-footer
    centered
    lazy
  >
    <b-form
      v-if="preset === 'dmarc'"
      @submit.prevent="submit"
    >
      <h2 class="text-xl text-center mb-8">
        Add DMARC Record Preset
      </h2>

      <table class="border-collapse table-auto w-full text-base">
        <thead>
          <tr>
            <th class="h-[40px] bg-[#F9F9F9] px-[20px] py-[10px]">
              Type
            </th>
            <th class="h-[40px] bg-[#F9F9F9] px-[20px] py-[10px]">
              Value
            </th>
            <th class="h-[40px] bg-[#F9F9F9] px-[20px] py-[10px]">
              TTL
            </th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr class="border-t border-[#D7D7D7]">
            <td class="px-[20px] py-[14px]">
              TXT
            </td>
            <td class="px-[20px] py-[14px] max-w-[200px] truncate">
              {{ `v=DMARC1; p=quarantine; rua=mailto:${form.rua_email}; sp=none; aspf=r;` }}
            </td>
            <td class="px-[20px] py-[14px]">
              5M
            </td>
          </tr>
        </tbody>
      </table>

      <b-form-group
        label="RUA Email"
        class="w-full mt-4 mb-0"
      >
        <b-input
          v-model="form.rua_email"
          type="email"
          @input="updateRUAEmail"
        />
      </b-form-group>

      <div class="inline-flex gap-x-[10px] mt-12">
        <b-btn
          variant="primary"
          type="submit"
          :disabled="loading"
        >
          Add Record
          <b-spinner
            v-if="loading"
            class="ml-2"
            variant="white"
            small
          />
        </b-btn>
        <b-btn
          variant="secondary"
          type="button"
          :disabled="loading"
          @click="() => modal = false"
        >
          Cancel
        </b-btn>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: 'DnsPresetModal',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => {}
    },
    preset: {
      type: String,
      default: ''
    }
  },
  computed: {
    modal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    updateRUAEmail (val) {
      this.form.value = `v=DMARC1; p=quarantine; rua=mailto:${val}; sp=none; aspf=r;`
    },
    submit () {
      this.$emit('submit')
    }
  }
}
</script>